<template>
    <div class="grid grid-cols-3 gap-4">
        <button
            v-for="option in options"
            :key="option.key"
            class="rounded-xl p-4 flex flex-col items-center justify-center transition border-2 h-28"
            type="button"
            :class="
                value.includes(option.key)
                    ? 'border-brand-red border-2 bg-theme-card'
                    : 'border-theme-border bg-theme-card hover:border-brand-red'
            "
            @click="toggle(option.key)"
        >
            <img
                v-if="option.icon"
                :src="option.icon"
                :alt="option.label"
                class="w-8 h-8 mb-2 object-contain"
            />
            <span class="text-sm text-theme-base">
                {{ option.label }}
            </span>
        </button>
    </div>
</template>

<script>
export default {
    name: "SocialNetworkPicker",

    props: {
        options: {
            type: Array,
            required: true
        },
        value: {
            type: Array,
            default: () => []
        }
    },

    methods: {
        toggle(key) {
            const updated = this.value.includes(key)
                ? this.value.filter((item) => item !== key)
                : [...this.value, key];
            this.$emit("input", updated);
        }
    }
};
</script>
